import React, { Component, createRef, Fragment } from "react";

import compose from "recompose/compose";
import PropTypes from "prop-types";

import { withStyles, withWidth } from "@material-ui/core";

export const styles = (theme) => ({
  main: {
    padding: "10px",
    backgroundColor: "white",
  },
});

class EmbeddedPage extends Component {
  containerRef = createRef();
  resizeObserver = null;

  componentDidMount() {
    this.sendHeight();
    window.addEventListener("resize", this.sendHeight);

    if (this.containerRef.current) {
      this.resizeObserver = new ResizeObserver(() => {
        this.sendHeight();
      });

      this.resizeObserver.observe(this.containerRef.current);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.sendHeight);

    if (this.resizeObserver && this.containerRef.current) {
      this.resizeObserver.unobserve(this.containerRef.current);
    }
  }

  sendHeight = () => {
    const height = this.containerRef?.current?.scrollHeight;
    height && window.parent.postMessage({ frameHeight: height }, "*");
  };

  render() {
    const { children, classes } = this.props;

    return (
      <section className={classes.main} ref={this.containerRef}>
        <Fragment>{children}</Fragment>
      </section>
    );
  }
}

EmbeddedPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  width: PropTypes.string.isRequired,
};

export default compose(withStyles(styles), withWidth())(EmbeddedPage);
